import { QueryHookOptions, QueryResult, useQuery } from '@apollo/client';
import { gql } from '@apollo/client/core';
import {
  SUBMISSION_PUBLIC_FRAGMENT,
  SubmissionPublicFragment,
} from '../fragment/submission.public.fragment';

export interface Data {
  submission: SubmissionPublicFragment;
}

export interface Variables {
  id: string;
}

export const QUERY = gql`
  query getSubmissionById($id: ID!) {
    submission: getSubmissionById(id: $id) {
      ...PublicSubmission
    }
  }

  ${SUBMISSION_PUBLIC_FRAGMENT}
`;

export const useSubmissionPublicQuery = (
  options?: QueryHookOptions<Data, Variables>
): QueryResult<Data, Variables> => useQuery<Data, Variables>(QUERY, options);
